/**
 * @file Re-exports the Footer component.
 */
import Footer from "./Footer";

export default Footer;
